// document.addEventListener('DOMContentLoaded', function () {
//   const mhCoursesSwiperEl = document.querySelector('.mh_courses_swiper_featured_compliance_courses');

//   if (!mhCoursesSwiperEl) return;

//   const mhCoursesSwiper = new Swiper(mhCoursesSwiperEl, {
//     observer: true,
//     observeParents: true,
//     resizeObserver: true,

//     slidesPerView: 1.3,
//     spaceBetween: 14,
//     loop: true,

//     grid: {
//       rows: 1,
//       fill: 'row'
//     },

//     autoplay: {
//       delay: 3500,
//       disableOnInteraction: false,
//       pauseOnMouseEnter: true
//     },

//     navigation: {
//       nextEl: '.mh_courses_next_{{ section.id }}',
//       prevEl: '.mh_courses_prev_{{ section.id }}'
//     },

//     breakpoints: {
//       576: {
//         slidesPerView: 1.5,
//         grid: {
//           rows: 1,
//           fill: 'row'
//         }
//       },
//       768: {
//         slidesPerView: 2,
//         spaceBetween: 20,
//         grid: {
//           rows: 2,
//           fill: 'row'
//         }
//       },
//       992: {
//         slidesPerView: 3,
//         spaceBetween: 24,
//         grid: {
//           rows: 2,
//           fill: 'row'
//         }
//       },
//       1280: {
//         slidesPerView: 3,
//         spaceBetween: 40,
//         grid: {
//           rows: 2,
//           fill: 'row'
//         }
//       }
//     },

//     on: {
//       init: function () {
//         this.update();
//       }
//     }
//   });

//   // Force update after the whole page (including images) has loaded
//   window.addEventListener('load', function () {
//     mhCoursesSwiper.update();
//     mhCoursesSwiper.updateSize();
//     mhCoursesSwiper.updateSlides();
//   });

//   // Additional delayed update in case Shopify sections/images affect layout
//   setTimeout(function () {
//     mhCoursesSwiper.update();
//     mhCoursesSwiper.updateSize();
//     mhCoursesSwiper.updateSlides();
//   }, 200);
// });

// COURSE DISCOUNT BANNER 
document.addEventListener('DOMContentLoaded', function () {
  let bars = document.querySelectorAll('.mh_discount_bar');

  bars.forEach(function (barWrapper) {
    let copyBtn = barWrapper.querySelector('.mh_discount_bar_copy_btn');
    let codeText = barWrapper.querySelector('.mh_discount_bar_code_value');
    let closeBtn = barWrapper.querySelector('.mh_discount_bar_close_btn');

    let popup = barWrapper.parentElement.querySelector('.mh_discount_bar_success_popup') ||
                document.querySelector('.mh_discount_bar_success_popup');
    let popupTextEl = popup ? popup.querySelector('span') : null;

    let popupTimeout;
    let successMessageTemplate = barWrapper.getAttribute('data-copy-success-message');
    let errorMessage = barWrapper.getAttribute('data-copy-error-message');

    let showPopup = function (message) {
      if (!popup || !popupTextEl) return;
      popupTextEl.textContent = message;
      popup.classList.add('mh_discount_bar_show');
      clearTimeout(popupTimeout);
      popupTimeout = setTimeout(function () {
        popup.classList.remove('mh_discount_bar_show');
      }, 2200);
    };

    if (copyBtn && codeText) {
      copyBtn.addEventListener('click', function () {
        let code = codeText.textContent.trim();
        let successMessage = successMessageTemplate
          ? successMessageTemplate.replace('[code]', code)
          : code + ' copied!';

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(code)
            .then(function () {
              showPopup(successMessage);
            })
            .catch(function () {
              showPopup(errorMessage);
            });
        } else {
          let tempInput = document.createElement('input');
          tempInput.value = code;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          showPopup(successMessage);
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        barWrapper.classList.add('mh_discount_bar_hide');

        let headerGroup = document.getElementById('shopify-section-sections--26602005201243__srs_header_dCdXcL');
        if (headerGroup) {
          headerGroup.style.top = '0';
        }
      });
    }

    let endTimestamp = parseInt(barWrapper.getAttribute('data-end-timestamp'), 10);

    let daysEl = barWrapper.querySelector('[id^="mh_discount_bar_days_"]');
    let hoursEl = barWrapper.querySelector('[id^="mh_discount_bar_hours_"]');
    let minutesEl = barWrapper.querySelector('[id^="mh_discount_bar_minutes_"]');
    let secondsEl = barWrapper.querySelector('[id^="mh_discount_bar_seconds_"]');

    let pad = function (num) {
      return String(num).padStart(2, '0');
    };

    let countdownInterval;

    let updateCountdown = function () {
      let now = new Date().getTime();
      let distance = endTimestamp - now;

      if (isNaN(endTimestamp) || distance <= 0) {
        clearInterval(countdownInterval);
        barWrapper.style.display = 'none';

        let headerGroup = document.getElementById('shopify-section-sections--26602005201243__srs_header_dCdXcL');
        if (headerGroup) {
          headerGroup.style.top = '0';
        }
        return;
      }

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    if (!isNaN(endTimestamp) && endTimestamp > 0) {
      updateCountdown();
      countdownInterval = setInterval(updateCountdown, 1000);
    } else {
      barWrapper.style.display = 'none';

      let headerGroup = document.getElementById('shopify-section-sections--26602005201243__srs_header_dCdXcL');
      if (headerGroup) {
        headerGroup.style.top = '0';
      }
    }

    /*
    let scrollHideOffset = parseInt(barWrapper.getAttribute('data-scroll-hide-offset'), 10) || 50;
    let ticking = false;

    let handleScroll = function () {
      if (window.scrollY > scrollHideOffset) {
        barWrapper.classList.add('mh_discount_bar_hide');
      } else {
        barWrapper.classList.remove('mh_discount_bar_hide');
      }
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    });
    */
  });
});